import React from 'react';
// import PropTypes from 'prop-types';
import WStoreButton from 'components/WStoreButton';
import DesktopNotification from '../DesktopNotification';
import WStoreIcon from './assets/Notifications_WStore.svg';

export default function WStoreReset({ ...rest }) {
  return (
    <DesktopNotification
      className="notification-wstore-reset"
      title={'WStore has reloaded!'}
      content={"The WStore just reloaded — come see what's in stock! "}
      iconSrc={WStoreIcon}
      footer={
        <WStoreButton
          to="/wstore"
          onClick={e => {
            rest.onClose(rest.notificationId);
          }}
        >
          <span>Join Now</span>
        </WStoreButton>
      }
      {...rest}
    />
  );
}
